/**
 * Method to scroll to an element inside a div
 * @param  {number} incrementValue height to which scroll in one step
 * @param  {HTMLElement} elem
 * @param  {HTMLElement} parentDiv parentDiv for which scroll enables (overflow is auto)
 */
export function animateScrollToBottomElement(incrementValue, elem, parentDiv) {
    if (elem && parentDiv) {
        let animationId;
        const scrollToDiv = () => {
            if (
                elem.offsetTop - parentDiv.scrollTop > incrementValue
				&& parentDiv.scrollTop + parentDiv.offsetHeight + incrementValue < parentDiv.scrollHeight
            ) {
                // eslint-disable-next-line no-param-reassign
                parentDiv.scrollTop += incrementValue;
                animationId = requestAnimationFrame(scrollToDiv);
            } else {
                cancelAnimationFrame(animationId);
            }
        };
        animationId = requestAnimationFrame(scrollToDiv);
    }
}
